/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { ListSubheader, TextField, Box } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import CustomSchema from '@/schema/CustomSchema';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { FormProvider } from 'react-hook-form';

import LoadingPanel from '@/component/common/LoadingPanel';
import ErrorMessageHeader from '../common/ErrorMessageHeader';
import '../common/ErrorMessageHeader.css';
import { Button } from '@material-ui/core';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { FormControl } from '@material-ui/core';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom, projectListInCorporationAtom, projectListInCorporationByUserIdAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { closeTabId, lastActivePanelIdAtom, multiPanelAtom, panelInitDataAtom, panelSettingAtom, panelStartIndexAtom } from '@/state/atom/panelAtom';
import { formListOfProjectSelector } from '@/state/selector/formSelector' ;
import {
    getListKnowledgeFormOfProject,
    getListMasterKnowledgeFormOfProject,
    getListSynonymKnowledgeFormOfProject,
} from '../common/layout/addTicket/handler/AddTicketHandler';
import { I18n } from 'aws-amplify';
import {
    acceptSoftDeleteDraftKnowledgeButton,
    acceptRestoreKnowledgeTicketDraft,
    checkIsDisableBtnDraftKnowledgeTicket,
    checkIsDisableBtnSentKnowledgeTicket,
    closeCallbackDeleteDraftKnowledgeButton,
    createKnowledgeTicketHandler,
    disabledAllField,
    handleOnchangeForm,
    initDataPanelCreateTicketKnowledge,
    initDataTicketKnowledgeDraft,
    onChangeFormCsv,
    onSubmitSaveDraftKnowledgeTicket,
    resetChatPermissionDefault,
    isDataInputUrlError,
    onConfirmChangeForm,
    isShowButtonDuplicate,
    isShowTimeBasedDelayResponseField,
} from './handler/KnowledgeTicketHandler';
import { triggerReloadTab, triggerReloadTicketListByPanelType, updatePanelAfterCreateTicketSelector } from '@/state/selector/panelSelector';
import { useSnackbar } from 'notistack';
import SettingPermissionKnowledgeTicket from './knowledge/SettingPermissionKnowledgeTicket';
import DialogSelectFormKnowledgeTicket from './listTicketDialog/DialogSelectFormKnowledgeTicket'
import {
    closePanelTabSelector,
    setPanelSelector
} from '@/state/selector/panelSelector';
import { DialogConfirmCancelCreateTicket } from './addTicketDialog/DialogConfirmCancelCreateTicket';
import { getAllTabPanelInitData, getPanelInitData, isPanelEdited, removePanelInitData, updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import { cloneDeep } from 'lodash';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import { sortKnowledgeTicketByOrder, viewTicketKnowledgeDetailDuplicate } from './handler/TicketHandler';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import { getListActiveB2BCustomerSelector, getListActiveB2BHelpdeskSelector } from '@/state/selector/ticketSelector';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { getTicketDetailAPI } from '@/service/ticketService';
import UpLoadCSVIcon from '../ticketKnowledge/icons/UpLoadCSVIcon';
import { mappingCsv, selectedFormCsv, handleStatusAtom, isClosePanelCsvAtom } from '@/state/atom/knowledgeCsvAtom';
import '../ticketKnowledge/KnowledgeTicket.css'
import { filterTagFieldRequired, filterFieldRequiredForTelephone, getPanelType } from './handler/CreateTicketCommonHandler';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import {
    getSettingPermissionDefault,
    closeCallbackRestoreKnowledgeTicketButton,
    acceptHardDeleteKnowledgeTicket,
    hasEditPermissionWithSpecialCase
} from '@/component/ticketKnowledge/handler/DetailTicketHandler';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import { isDisplayOptionSearchSynonym } from '../ticketKnowledge/handler/DrilldownAndDetailSearchHandler';
import { openShareLinkTicket } from '../chatThread/handler/MessageHandler';
import { getFormById } from '@/service/formManagementService';
import TicketBookmark from '../ticketKnowledge/elements/Bookmark/TicketBookmark';
import { signOut } from '@/service/authenService';
import AiAutoLog from './knowledge/AiAutoLog';
import SDautoLog from './knowledge/SDautoLog';
import TelephonePromptLog from '../ticketList/knowledge/TelephonePromptLog'
import { AutoPassSystemFieldInSchema } from '../../common/constant/SystemField';
import { PropTypes } from 'prop-types';
import CreateKnowledgeGroupActionButton from './CreateKnowledgeGroupActionButton';
import WrapRenderFieldUI from '../ticketKnowledge/WrapRenderFieldUI';


const AI_TELEPHONE_PAIRED_FIELDS = {
    [Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_TIME]: Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_TIME,
    [Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE]: Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE,
};
const AI_TELEPHONE_SKIP_FIELDS = Object.values(AI_TELEPHONE_PAIRED_FIELDS);

KnowledgeTicket.propTypes = {
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    ticketId: PropTypes.any,
    detailTicket: PropTypes.any,
    isSoftDeleted: PropTypes.any,
    isDuplicate: PropTypes.any,
    isDraft: PropTypes.any,
    API: PropTypes.any,
};

export default function KnowledgeTicket(props) {
    const panelChildren = window.innerWidth > 991 ? 3 : 1;
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [currentIndex, setCurrentIndex] = useRecoilState(panelStartIndexAtom);
    const [settingSlide, setSettingSlide] = useRecoilState(panelSettingAtom);
    const [isExChangeTagField, setIsExChangeTagField] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [listFieldEdited, setListFieldEdited] = useState([])
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUpdatedList, setFileUpdatedList] = useState([]);
    const [userDetail, setUserDetail] = useRecoilState(userAtom);
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);
    const corporationDetail = useRecoilValue(
        corporationAtom
    );
    
    const lastActivePanelId = useRecoilValue(lastActivePanelIdAtom);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const setSelectedFormCsv = useSetRecoilState(selectedFormCsv);
    const [formList, setFormList] = useRecoilState(formListOfProjectSelector);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [knowledgeFormList, setKnowledgeFormList] = useState([]);
    const [knowledgeAIAutoFormList, setKnowledgeAIAutoFormList] = useState([]);
    const [knowledgeSDAutoFormList, setKnowledgeSDAutoFormList] = useState([]);
    const [businessAppFormList, setBusinessAppFormList] = useState([]);
    const [masterKnowledgeFormList, setMasterKnowledgeFormList] = useState([]);
    const [synonymKnowledgeFormList, setSynonymKnowledgeFormList] = useState([]);
    const [isEdited, setIsEdited] = useState(false);
    const [onChangeEdit,setOnChangeEdit] = useState(false);
    const [currentPanelInitData, setCurrentPanelInitData] = useState({});
    const [isLoadingInitData, setIsLoadingInitData] = useState(false);
    const [flagReset, setFlagReset] = useState(false);
    const [submitTime,setSubmitTime]= useState('')

    //state setting permissions
    const [dataSettingDefaults, setDataSettingDefaults] = useState({});
    const [viewPermissions, setViewPermissions] = useState([]);
    const [editPermissions, setEditPermissions] = useState([]);
    const [additionalViewPermissions, setAdditionalViewPermissions] = useState([]);
    const [additionalEditPermissions, setAdditionalEditPermissions] = useState([]);
    const [chatPermission, setChatPermission] = useState('');
    const [isSelectedViewPermissions, setIsSelectedViewPermissions] = useState(false);
    const [isSelectedEditPermissions, setIsSelectedEditPermissions] = useState(false);
    const [isChangeFormDraftMode, setIsChangeFormDraftMode] = useState(false);

    const listB2BCustomerRecoilState = useRecoilValue(getListActiveB2BCustomerSelector);
    const listB2BHelpdeskRecoilState = useRecoilValue(getListActiveB2BHelpdeskSelector);
    const listProjectInCorp = useRecoilValue(projectListInCorporationAtom);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const setLastUserAction = useSetRecoilState(helpdeskTicketLastUserActionAtom);

    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenNotFoundTicketPopup,setIsOpenNotFoundTicketPopup] = useState(false);
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);
    const [isShowAiAutoLog, setIsShowAiAutoLog] = useState(false);
    const [isShowSDautoLog, setIsShowSDautoLog] = useState(false);
    const [isShowAITelephonePromptLog, setIsShowAITelephonePromptLog] = useState(false);
    const [errorMessageHeader, setErrorMessageHeader] = useState('');

    /**
     * created for ai auto. this state will be set options by dependent field. ex: ai auto. selected ticket type field , will be query form list by ticket type.
     * this state value is format array object with key which is any. !) with ai auto: key is sysField of dependent field.
     */
    const [optionsOfTagField, setOptionsOfTagField] = useState({})
    const [aiAutoSelectedData, setAIAutoSelectedData] = useState({});
    const [sdautoSelectedData, setSdautoSelectedData] = useState({});
    const [aiTelephoneSelectedData, setAITelephoneSelectedData] = useState({});
    const [aiTelephoneEndDateValue, setAiTelephoneEndDateValue] = useState(null);
    const onClickUrlViewTicket = async (url) => {
        setIsLoading(true)
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            props?.API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            userDetail.id,
            projectInuseDetail.id,
            {
                ...props,
                setIsLoading,
                API: props?.API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setProjectInuseDetail,
                userDetail: userDetail,
                setUserDetail: setUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    }

    useEffect(() => {
        let listFormKnowledge = getListKnowledgeFormOfProject(
            formList,
            projectInuseDetail.id,
            corporationDetail
        );
        
        listFormKnowledge = listFormKnowledge.filter(form => {
            if (Utils.isSystemAIAutoForm(form)) {
                return Utils.isCorporationOnAIAuto(corporationDetail)
            }

            if (Utils.isSystemSDAutoForm(form))
                return Utils.isCorporationOnSDAuto(corporationDetail);

            if (Utils.isSystemFormChatAIPrompt(form)) {
                if (Utils.isCorporationOnAI(corporationDetail) && Utils.isCorporationOnKnowledge(corporationDetail)) return true;
                return false;
            }

            if (Utils.isSystemFormAITelephonePrompt(form)) {
                if (
                    Utils.isProjectOnAiTelephoneAgent(projectInuseDetail) &&
                    Utils.isCorporationOnKnowledge(corporationDetail) &&
                    Utils.isEnableSettingTelephoneAgent(corporationDetail)
                ) {
                    return true;
                }else{
                    return false;
                }
            }

            if (Utils.isSystemFormAITrainingPrompt(form)) {
                if (
                    Utils.isProjectOnAiTelephoneAgent(projectInuseDetail) &&
                    Utils.isCorporationOnKnowledge(corporationDetail) &&
                    Utils.isEnableSettingTelephoneAgent(corporationDetail) &&
                    Utils.isProjectDeskOn(projectInuseDetail)
                ) {
                    return true;
                } else {
                    return false;
                }
            }

            if (Utils.isSystemFormAIAssistantPrompt(form)) {
                if (
                    Utils.isCorporationOnKnowledge(corporationDetail) &&
                    Utils.isCorporationOnAIAuto(corporationDetail) &&
                    Utils.isProjectOnAiTelephoneAgent(projectInuseDetail) &&
                    Utils.isEnableSettingTelephoneAgent(corporationDetail) &&
                    Utils.isProjectDeskOn(projectInuseDetail)
                ) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        });


        let listFormMasterKnowledge = getListMasterKnowledgeFormOfProject(formList, projectInuseDetail.id, corporationDetail);
        listFormKnowledge = sortKnowledgeTicketByOrder(listFormKnowledge, argsAll);
        listFormMasterKnowledge = sortKnowledgeTicketByOrder(listFormMasterKnowledge, argsAll);
        if(isDisplayOptionSearchSynonym(corporationDetail,projectInuseDetail)){
            listFormKnowledge = listFormKnowledge.filter(form => {
                return !form?.isSynonym
            });
             let listFormSynonym = getListSynonymKnowledgeFormOfProject(formList, projectInuseDetail.id);
             listFormSynonym = listFormSynonym.map(form => Utils.setDefaultPermissionForSynonymForm(form));
             listFormSynonym = sortKnowledgeTicketByOrder(listFormSynonym, argsAll);
             setSynonymKnowledgeFormList(listFormSynonym)
        }else{
            setSynonymKnowledgeFormList([])
        }

        const aiAutoFormList = listFormKnowledge.filter(form => {
            return (
                Utils.isSystemAIAutoForm(form) ||
                (form.type === Constant.FORM_TYPE.FORM_KNOWLEDGE &&
                    form.promptKnowledgeFormFlag === Constant.PROMPT_FLAG.TRUE)
            );
        });

        let systemAIAutoForms = aiAutoFormList.filter(form => {
            return Utils.isSystemAIAutoForm(form) || Utils.isSystemFormChatAIPrompt(form);
        });

        const sdAutoForms = listFormKnowledge.filter(form => Utils.isSystemSDAutoForm(form));
        const businessAppForms = listFormKnowledge.filter(form => Utils.isSystemBusinessAppForm(form));

        let systemForms = systemAIAutoForms.map(form => {
            let sortKey = Constant.SYSTEM_FORM_ORDER.DEFAULT;
            if (Utils.isSystemFormChatAIPrompt(form))
                sortKey = Constant.SYSTEM_FORM_ORDER.FORM_AI_CHAT_PROMPT;

            if (Utils.isSystemAIAutoForm(form)) {
                switch (form?.definitionVariant) {
                    case Constant.FORM_VARIANT.AI_AUTO.EVENT:
                        sortKey = Constant.SYSTEM_FORM_ORDER.FORM_AI_AI_AUTO_EVENT;
                        break;
                    case Constant.FORM_VARIANT.AI_AUTO.TIMER:
                        sortKey = Constant.SYSTEM_FORM_ORDER.FORM_AI_AI_AUTO_TIMER;
                        break;
                    case Constant.FORM_VARIANT.AI_AUTO.PERIODIC:
                        sortKey = Constant.SYSTEM_FORM_ORDER.FORM_AI_AI_AUTO_PERIODIC;
                        break;
                    default:
                        sortKey = Constant.SYSTEM_FORM_ORDER.DEFAULT;
                }
            }
            return {
                ...form,
                sortKey
            }
        })
        systemForms = systemForms.sort((a, b) => a.sortKey - b.sortKey);

        let userChatAIPrompt = aiAutoFormList.filter(form => {
            return (
                !Utils.isSystemAIAutoForm(form) &&
                !Utils.isSystemFormChatAIPrompt(form) &&
                !Utils.isSystemSDAutoForm(form)
            );
        });

        listFormKnowledge = listFormKnowledge.filter(form => {
            return (
                !Utils.isSystemAIAutoForm(form) &&
                !Utils.isSystemFormChatAIPrompt(form) &&
                form?.promptKnowledgeFormFlag !== Constant.PROMPT_FLAG.TRUE &&
                !Utils.isSystemSDAutoForm(form) &&
                !Utils.isSystemBusinessAppForm(form)
            );
        });

        userChatAIPrompt = userChatAIPrompt.filter(form => {
            if (Utils.isSystemFormAITelephonePrompt(form)) {
                if (
                    Utils.isProjectOnAiTelephoneAgent(projectInuseDetail) &&
                    Utils.isCorporationOnKnowledge(corporationDetail) &&
                    Utils.isEnableSettingTelephoneAgent(corporationDetail)
                ) {
                    return true;
                }else{
                    return false;
                }
            }

            if (Utils.isSystemFormAITrainingPrompt(form)) {
                if (
                    Utils.isProjectOnAiTelephoneAgent(projectInuseDetail) &&
                    Utils.isCorporationOnKnowledge(corporationDetail) &&
                    Utils.isEnableSettingTelephoneAgent(corporationDetail) &&
                    Utils.isProjectDeskOn(projectInuseDetail)
                ) {
                    return true;
                } else {
                    return false;
                }
            }

            if (Utils.isSystemFormAIAssistantPrompt(form)) {
                if (
                    Utils.isCorporationOnKnowledge(corporationDetail) &&
                    Utils.isCorporationOnAIAuto(corporationDetail) &&
                    Utils.isProjectOnAiTelephoneAgent(projectInuseDetail) &&
                    Utils.isEnableSettingTelephoneAgent(corporationDetail) &&
                    Utils.isProjectDeskOn(projectInuseDetail)
                ) {
                    return true;
                } else {
                    return false;
                }
            }

            return true;
        });
        setKnowledgeFormList(listFormKnowledge);
        setKnowledgeAIAutoFormList([...userChatAIPrompt, ...systemForms]);
        setKnowledgeSDAutoFormList(sdAutoForms)
        setBusinessAppFormList(businessAppForms)
        setMasterKnowledgeFormList(listFormMasterKnowledge);
    }, [formList, projectInuseDetail])

    // state of formList
    const [isErrorSelected, setIsErrorSelected] = useState(false);
    const [fieldListData, setFiledListData] = useState([]);
    const [selectedForm, setSelectedForm] = useState('');
    const [selectedFormDetail, setSelectedFormDetail] = useState({});
    const [autoFillObject, setAutoFillObject] = useState({});
    const [isOpenDialogSelectForm, setIsOpenDialogSelectForm] = useState({isOpen: false, value: ''});
    const validateCreateKnowledgeTicket = useForm({
        mode: 'all',
        resolver: yupResolver(CustomSchema(fieldListData)),
    });
    const handleSubmitCreateKnowledgeTicket = validateCreateKnowledgeTicket.handleSubmit;
    const errorCreateKnowledgeTicket = validateCreateKnowledgeTicket.errors;

    
    const unregisterCreateKnowledgeTicket = validateCreateKnowledgeTicket.unregister;
    const setValueCreateKnowledgeTicket = validateCreateKnowledgeTicket.setValue;
    const getValuesCreateKnowledgeTicket = validateCreateKnowledgeTicket.getValues;
    const registerCreateKnowledgeTicket = validateCreateKnowledgeTicket.register;
    const resetValuesCreateKnowledgeTicket = validateCreateKnowledgeTicket.reset;
    const setErorsCreateKnowledgeTicket = validateCreateKnowledgeTicket.setError;
    const clearErrors = validateCreateKnowledgeTicket.clearErrors;
    const controlValueCreateKnowledgeTicket = validateCreateKnowledgeTicket.control;
    const triggerValidate = validateCreateKnowledgeTicket.trigger;

    const [isDisableButtonSent, setIsDisableButtonSent] = useState(true);
    const [isDisableButtonDraft, setIsDisableButtonDraft] = useState(true);
    const [isConfirmCancelCreateTicket, setIsConfirmCancelCreateTicket] = useState(false);
    const [selectedFormInfo, setSelectedFormInfo] = useState({});
    const ticketType = Constant.TICKET_TYPE.KNOWLEDGE;
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);

    const [triggerSaveFormData, setTriggerSaveFormData] = useState('');

    const draftTicketData = props?.draftData || {};
    const [isDraftMode, setIsDraftMode] = useState(props.detailTicket && !Utils.isEmptyObject(props.detailTicket) ? true : false);
    const detailTicket = props.detailTicket;
    const isSoftDeleted = props.isSoftDeleted;

    const { enqueueSnackbar } = useSnackbar();

    // Delete draft knowledge ticket
    const [isOpenDialogConfirmDeleteDraftKnowledge, setIsOpenDialogConfirmDeleteDraftKnowledge] = useState(false);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const reloadPanelAfterSoftDeleteTicketByPanelType = useSetRecoilState(triggerReloadTab);
    // Restore button
    const [isShowDialogRestoreTicket, setIsShowDialogRestoreTicket] = useState(false);
    // Delete button
    const [isShowDialogDeleteTicket, setIsShowDialogDeleteTicket] = useState(false);

    const mapping = useRecoilValue(mappingCsv);
    const [isShowPopUpConfirmChangeForm, setIsShowPopUpConfirmChangeForm] = useState({status: false});
    const [handleStatus, setHandleStatus] = useRecoilState(handleStatusAtom);
    const isClosePanelCsv = useRecoilValue(isClosePanelCsvAtom)
    const [isShowDialogCloseTabCaseEditedCsv, setIsShowDialogCloseTabCaseEditedCsv] = useState(false);
    const [isOpenClosePanelCsv, setIsOpenClosePanelCsv] = useState(false);
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);
    const userOfProjectList = useRecoilValue(projectListInCorporationByUserIdAtom);
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: I18n.get('MSG-CM-DELETED-CONTENT'),
        confirmTxt: I18n.get('CM-BUTTON-OK')
    });

    const { watch } = validateCreateKnowledgeTicket;
    const allFormData = watch(); 


    const [displayMode, setDisplayMode] = useState(!Utils.isEmptyObject(props.detailTicket) && !props.isDuplicate ? Constant.DISPLAY_MODE.VIEW : Constant.DISPLAY_MODE.EDIT);

    const argsAll = {
        ...props,
        panelChildren,
        panelList,
        panelId: props.panelId,
        currentIndex,
        settingSlide,
        setIsLoading,
        setPanelListRecoilState: setPanelList,
        setCurrentIndex,
        setSettingSlide,
        API: props?.API,

        formList: formList,
        setFormList: setFormList,
        projectInuseDetail: projectInuseDetail,
        knowledgeFormList: knowledgeFormList,
        setKnowledgeFormList: setKnowledgeFormList,
        masterKnowledgeFormList, 
        setMasterKnowledgeFormList,
        isOpenDialogSelectForm,
        setIsOpenDialogSelectForm,
        setValueCreateKnowledgeTicket,
        getValuesCreateKnowledgeTicket,
        unregisterCreateKnowledgeTicket,
        resetValuesCreateKnowledgeTicket,
        isEdited,
        setIsEdited,
        isDisableButtonSent,
        setIsDisableButtonSent,
        isDisableButtonDraft,
        setIsDisableButtonDraft,
        closePanelTab,
        isConfirmCancelCreateTicket,
        setIsConfirmCancelCreateTicket,
        selectedFormInfo,
        setSelectedFormInfo,
        ticketType,
        panelInitData,
        setPanelInitData,
        currentPanelInitData,
        setCurrentPanelInitData,
        isLoadingInitData,
        setIsLoadingInitData,
        setFileUpdatedList,
        fileUpdatedList,
        fileUploadList,
        setFileUploadList,
        setIsChangeFormDraftMode,
        isChangeFormDraftMode,

        errorMessageHeader,
        setErrorMessageHeader,

        isErrorSelected: isErrorSelected,
        setIsErrorSelected: setIsErrorSelected,

        selectedForm: selectedForm,
        setSelectedForm: setSelectedForm,
        selectedFormDetail, 
        setSelectedFormDetail,

        fieldListData,
        setFiledListData,

        // selectedPublicRange,
        // setSelectedPublicRange,

        updatePanelAfterCreateTicket: useSetRecoilState(updatePanelAfterCreateTicketSelector),
        enqueueSnackbar,

        viewPermissions, 
        setViewPermissions,
        editPermissions, 
        setEditPermissions,
        additionalViewPermissions, 
        setAdditionalViewPermissions,
        additionalEditPermissions, 
        setAdditionalEditPermissions,
        chatPermission, 
        setChatPermission,
        isSelectedViewPermissions,
        setIsSelectedViewPermissions,
        isSelectedEditPermissions,
        setIsSelectedEditPermissions,
        dataSettingDefaults,
        setDataSettingDefaults,

        setIsOpenModalReloadPage,
        handleOnchangeForm,

        draftTicketData,
        triggerSaveFormData,
        setTriggerSaveFormData,
        isDraftMode,
        setIsDraftMode,
        detailTicket,

        listB2BCustomerRecoilState,
        listB2BHelpdeskRecoilState,
        listProjectInCorp,
        corporationDetail,
        isOpenDialogConfirmDeleteDraftKnowledge, 
        setIsOpenDialogConfirmDeleteDraftKnowledge,
        reloadTicketListByPanelType,
        reloadPanelAfterSoftDeleteTicketByPanelType,
        setSelectedFormCsv,
        mapping,
        setIsShowPopUpConfirmChangeForm,
        handleStatus,
        setHandleStatus,
        setLastUserAction,
        flagReset,
        setFlagReset,
        isShowDialogRestoreTicket,
        setIsShowDialogRestoreTicket,
        isShowDialogDeleteTicket,
        setIsShowDialogDeleteTicket,
        triggerReload: props.triggerReload,
        setUserDetail,
        userDetail,
        setIsShowPopupLogout,
        setIsShowAiAutoLog,
        setIsShowSDautoLog,
        setIsShowAITelephonePromptLog,
        clearErrors,
        aiAutoSelectedData,
        setAIAutoSelectedData,
        sdautoSelectedData,
        setSdautoSelectedData,
        aiTelephoneSelectedData,
        setAITelephoneSelectedData,
        errorCreateKnowledgeTicket,
        setErorsCreateKnowledgeTicket
    };

    useEffect(() => {
        if(!isDraftMode) {
            setIsLoading(true);
            setFiledListData([]);
            setAdditionalViewPermissions([]);
            setViewPermissions([]);
            setEditPermissions([]);
            setAdditionalEditPermissions([]);
            setChatPermission('');
            let dataSettingDefault = {
                viewPermission: [],
                editPermission: [],
                additionalViewPermission: '',
                additionalEditPermission: '',
                chatPermission: ''
            };
            setDataSettingDefaults(dataSettingDefault);
            (async () => {
                await onChangeFormCsv(argsAll, '');
            })();
        }
        
    }, [isClosePanelCsv]);

    useEffect(() => {
        const ticketId = props.ticketId
        if (!ticketId) return;

        setIsLoading(true);
        //get ticket detail
        getTicketDetailAPI(props?.API, props.ticketId).then(ticketDetailResult => {
            let ticket = cloneDeep(ticketDetailResult.detailTicket);

            let newDataSettingDefaults = {
                viewPermission: ticket?.viewPermission,
                editPermission: ticket?.editPermission,
                additionalViewPermission: ticket?.additionalViewPermission,
                additionalEditPermission: ticket?.additionalEditPermission,
                chatPermission: ticket?.chatPermission
            };
            if (props?.isDuplicate) {
                newDataSettingDefaults = {
                    viewPermission: [Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY, Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT],
                    editPermission: [Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY, Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PROJECT_MANAGER],
                    additionalViewPermission: '',
                    additionalEditPermission: '',
                    chatPermission: resetChatPermissionDefault(ticket?.viewPermission, ticket?.chatPermission)
                };
                setIsEdited(true);
                let fileDuplicateList = [];
                const attachment = ticket.attachment
                if (!Utils.isEmptyArray(attachment)) {
                    for (let file of attachment) {
                        let fileDuplicateData = {
                            file: {
                                path: file.fileUrl,
                                lastModified: Date.now().toString(),
                                lastModifiedDate: Date.now().toString(),
                                name: file.fileName,
                                size: file.fileSize,
                                fileUrl: file?.fileUrl
                            },
                            fileName: file.fileName,
                            fileSize: file.fileSize,
                            isExpand: true,
                            isPdf: file.isPdf,
                            key: '',
                            progress: 0,
                            splitPdf: file.splitPdf,
                            status: true,
                            isDuplicate: true
                        }
                        if (file.isPdf) {
                            fileDuplicateData.isCreatingPageKnowledge = true;
                        }
                        fileDuplicateList.push(fileDuplicateData)
                    }
                }

                setFileUploadList(fileDuplicateList)
                setValueCreateKnowledgeTicket(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, fileDuplicateList);
            }
                setDataSettingDefaults(newDataSettingDefaults);
        });
        setIsLoading(false)
    }, [props.triggerReload]);

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isEdited);
    }, [isEdited])

    // Save state displayMode
    useEffect(() => {
        clearErrors();
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'displayMode', displayMode);
    }, [displayMode])

    useEffect(() => {
        let newArgsAll = cloneDeep(argsAll);
        delete newArgsAll.panelInitData;
        delete newArgsAll.currentPanelInitData;
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'argsAll', newArgsAll);
        if(!Utils.isEmptyObject(selectedFormDetail)) {
            
            let initSettingDefault = {
                viewPermission: selectedFormDetail?.viewPermission ? selectedFormDetail?.viewPermission : [],
                editPermission: selectedFormDetail.editPermission ? selectedFormDetail.editPermission : [],
                additionalViewPermission: '',
                additionalEditPermission: '',
                chatPermission: selectedFormDetail.chatPermission
            };
            let dataSettingDefault = {...initSettingDefault}

            // when editTicket (https://new.redmine.ominext.com/issues/85837)
            if(!Utils.isEmptyObject(detailTicket)) {
                dataSettingDefault = getSettingPermissionDefault(initSettingDefault, props.panelId, props.tabId, panelInitData);
            }

            setDataSettingDefaults(dataSettingDefault);
        }
    },[selectedFormDetail])

    useEffect(() => {
        resetValuesCreateKnowledgeTicket();
        validateCreateKnowledgeTicket.register('fileUploadList');
        validateCreateKnowledgeTicket.register('publicRange');
        validateCreateKnowledgeTicket.register('attachments');

        let currentPanelInitDataRes = getPanelInitData(props.panelId, props.tabId, panelInitData);
        if (currentPanelInitDataRes && !Utils.isEmptyObject(currentPanelInitDataRes)) {
            setCurrentPanelInitData(currentPanelInitDataRes);
            if (currentPanelInitDataRes.argsAll) {
                setIsLoadingInitData(true);
                initDataPanelCreateTicketKnowledge(currentPanelInitDataRes, argsAll).then(result => {
                    setIsLoadingInitData(false);
                }).catch(error => {
                    setIsLoadingInitData(false);
                }).finally(error => {
                    setIsLoadingInitData(false);
                })
            }

            // set display mode for createNew of duplicate ticket
            if (Utils.isEmptyObject(props.detailTicket) || props.isDuplicate) {
                setDisplayMode(Constant.DISPLAY_MODE.EDIT);
            } else if (currentPanelInitDataRes?.displayMode) {
                setDisplayMode(currentPanelInitDataRes?.displayMode);
            }
        }

        if (props.isDraft || props.detailTicket?.public === Constant.TICKET_PUBLIC.DRAFT) {
            initDataTicketKnowledgeDraft(argsAll, currentPanelInitDataRes);
        }
        

        let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
        let lastFormOfProject = workLastForm[projectInuseDetail.id];
        if (
            lastFormOfProject &&
            !props.isDraft &&
            props?.detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT &&
            Utils.isEmptyString(currentPanelInitDataRes?.argsAll?.selectedForm)
        ) {
            setIsLoadingInitData(true);
            initDataLastForm(lastFormOfProject).then(result => {
                setIsLoadingInitData(false);
            }).catch(error => {
                console.log('initDataLastForm >>> error:', error);
                setIsLoadingInitData(false);
            }).finally(() => {
                setIsLoadingInitData(false);
            });
        }
    }, []);

    const initDataLastForm = async (lastFormOfProject) => {
        setIsLoadingInitData(true);
        let lastFormKnowledgeOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_KNOWLEDGE];
        if (!Utils.isEmptyObject(lastFormKnowledgeOfProject)) {
            // Validate form
            let formDetail = await getFormById(props?.API, lastFormKnowledgeOfProject?.formId);
            if (Utils.isEmptyObject(formDetail) || !formDetail.usingProjects.includes(projectInuseDetail.id)) {
                return;
            }
            // corp off AiAuto
            let isCorporationOnAIAuto = Utils.isCorporationOnAIAuto(corporationDetail);
            if ((Utils.isSystemSDAutoForm(formDetail) || Utils.isSystemAIAutoForm(formDetail)) && !isCorporationOnAIAuto) {
                return;
            }
            await onConfirmChangeForm(lastFormKnowledgeOfProject?.formId, argsAll)
        }
    }

    useEffect(() => {
        let newArgsAll = cloneDeep(argsAll);
        delete newArgsAll.panelInitData;
        delete newArgsAll.currentPanelInitData;
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'argsAll', newArgsAll);

        let settingPermission = {
            viewPermission: viewPermissions,
            editPermission: editPermissions,
            additionalViewPermission: additionalViewPermissions,
            additionalEditPermission: additionalEditPermissions,
            chatPermission: chatPermission
        };
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'settingPermission', settingPermission);
    }, [
        fieldListData,
        fileUploadList,
        viewPermissions,
        editPermissions,
        chatPermission,
        additionalViewPermissions,
        additionalEditPermissions,
        aiAutoSelectedData,
        sdautoSelectedData,
        aiTelephoneSelectedData,
    ]);

    useEffect(() => {
        if ((lastActivePanelId && lastActivePanelId.panelId === props.panelId && lastActivePanelId.tabId === props.tabId) || triggerSaveFormData) {
            let formData = getValuesCreateKnowledgeTicket();
            if (!Utils.isEmptyArray(fieldListData)) {
                let fieldAttachments = fieldListData.find(field => field.sysField === 'attachments');
                if (!Utils.isEmptyObject(fieldAttachments)) {
                    let defaultFileUpload = [];
                    if (!Utils.isEmptyArray(fileUpdatedList)) {
                        defaultFileUpload = fileUpdatedList.filter(file => !file.isDelete);
                    } else if (!Utils.isEmptyArray(fieldAttachments.defaultValue)) {
                        defaultFileUpload = fieldAttachments.defaultValue;
                    } else if (!Utils.isEmptyArray(fieldAttachments.value)) {
                        defaultFileUpload = fieldAttachments.value;
                    }
                    formData[fieldAttachments.id] = defaultFileUpload;
                    formData['fileUploadList'] = defaultFileUpload;
                }
            }
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'formData', formData);
        }
    }, [lastActivePanelId, triggerSaveFormData]);

    useEffect(() => {
        setIsDisableButtonSent(checkIsDisableBtnSentKnowledgeTicket(argsAll, aiAutoSelectedData, sdautoSelectedData, aiTelephoneSelectedData));
        setIsDisableButtonDraft(checkIsDisableBtnDraftKnowledgeTicket(argsAll));
    })

    const onClosePanelCsv = () => {
        setIsOpenClosePanelCsv(false);
        setHandleStatus(prev => {
            if (prev !== Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_SUCCESS) {
                return Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START;
            }
            return prev;
        });
    };

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            let csvPanelInfo = panelList.find(panel => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV);
            let isEditedCsv = false;
            let isTabRoot = props.tabId === csvPanelInfo?.tabList[0]?.id;
            if(!Utils.isEmptyObject(csvPanelInfo) && isTabRoot) {
                let allTabInitData = getAllTabPanelInitData(csvPanelInfo.id, panelInitData);
                isEditedCsv = isPanelEdited(allTabInitData);
                if (
                    isEditedCsv &&
                    ![
                        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START,
                        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE
                    ].includes(argsAll.handleStatus)
                ) {
                    setIsShowDialogCloseTabCaseEditedCsv(true);
                }

                if (
                    [
                        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START,
                        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE
                    ].includes(argsAll.handleStatus)
                ) {
                    setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE);
                    setIsOpenClosePanelCsv(true);
                    setCloseTabIdState(0);
                    return;
                }
            }

            if(!isEditedCsv || !isTabRoot) {
                if (isEdited || props.isDuplicate) {
                    setIsConfirmCancelCreateTicket(true);
                } else {
                    let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                    if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                    closePanelTab({
                        event: null,
                        panelType: currentPanelInfo.type,
                        panelId: props.panelId,
                        tabId: props.tabId
                    });
                    removePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData);
                    setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_INITIAL);
                }
            }

            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    const onSubmitCreateKnowledgeTicket = (formData) => {
        let listTagField = fieldListData?.filter(fieldData => fieldData.structure.UI === Constant.FIELD_UI.TAG || fieldData.structure.UI === Constant.FIELD_UI.TEXT_WITH_CHIP)
        let listTagFieldRequire = listTagField?.filter(field => field?.structure?.required);
        listTagFieldRequire = listTagFieldRequire.filter(field => !AutoPassSystemFieldInSchema.includes(field.sysField));
        let isTelephoneForm = fieldListData?.some(field => field.sysField?.startsWith(Constant.ID_PREFIX.AI_TELEPHONE_FIELD_ID_PREFIX));
        if (isTelephoneForm) {
            listTagFieldRequire = filterFieldRequiredForTelephone(listTagFieldRequire, aiTelephoneSelectedData);
        } else {
            listTagFieldRequire = filterTagFieldRequired(listTagFieldRequire, aiAutoSelectedData, sdautoSelectedData);
        }

        let isError = false;
        let fieldListDataClone = cloneDeep(fieldListData)
        /**validate tag field required. start */
        listTagFieldRequire?.forEach(field => {
            const fieldValue = formData[field.id]
            if(Utils.isEmptyArray(fieldValue)){
                isError = true;
                let indexOfField = fieldListDataClone.findIndex(fieldData => fieldData.id === field.id);
                let fieldData = fieldListDataClone[indexOfField];
                fieldData.error = {
                    isError: true,
                    message: I18n.get('COMM01MSG11')
                }
                fieldListDataClone[indexOfField] = fieldData
            }
        })
        /**validate tag field required.end */

        /**validate AI Telephone time_based_delay_response required.start */
        if (isTelephoneForm) {
            const delayResponseField = fieldListData?.find(
                field => field.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_TIME_BASED_DELAY_RESPONSE
            );
            
            if (delayResponseField && delayResponseField.structure?.required) {
                const shouldValidate = isShowTimeBasedDelayResponseField(aiTelephoneSelectedData);
                
                if (shouldValidate) {
                    const fieldValue = formData[delayResponseField.id];
                    if (Utils.isEmpty(fieldValue) || fieldValue === '' || fieldValue === null) {
                        isError = true;
                        let indexOfField = fieldListDataClone.findIndex(f => f.id === delayResponseField.id);
                        if (indexOfField !== -1) {
                            fieldListDataClone[indexOfField].error = {
                                isError: true,
                                message: 'このフィールドは入力必須です。'
                            };
                        }
                    }
                }
            }
        }
        /**validate AI Telephone time_based_delay_response required.end */

        /**validate fields data time fields.start */
        const dateFields = fieldListData?.filter(field=> field?.structure?.UI === Constant.FIELD_UI.DATE)
        dateFields?.forEach(dateField => {
            const dataFieldValue = formData[dateField?.id];
            const indexOfField = fieldListDataClone.findIndex(
                fieldData => fieldData?.id === dateField?.id
            );
            const fieldData = fieldListDataClone[indexOfField];

            switch (dateField?.structure?.dateFormat) {
                case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMM:
                    if (dateField?.structure?.minutesStep) {
                        const { status, errorMessage } = Utils.validateDateByMinutesStep(
                            dataFieldValue,
                            dateField?.structure?.minutesStep
                        );
                        if (!status) {
                            isError = true;
                            fieldData.error = {
                                isError: true,
                                message: errorMessage
                            };
                            fieldListDataClone[indexOfField] = fieldData;
                            setFiledListData([...fieldListDataClone]);
                        }
                    }
                    break;
                default:
            }
        });
        /**validate fields data time fields.end */
        if(isError) {
            setSubmitTime(new Date().getTime())
            return;
        };

        if (checkIsDisableBtnSentKnowledgeTicket(argsAll, aiAutoSelectedData, sdautoSelectedData, aiTelephoneSelectedData) && props.isDuplicate) {
            return;
        }

        return createKnowledgeTicketHandler(
            props.tabId,
            props.panelType,
            formData,
            userDetail,
            corporationDetail,
            props.panelId,
            argsAll,
            fieldListData,
            aiAutoSelectedData,
            sdautoSelectedData
        );
    };

    const handleSubmitSaveDraft = () => {
        let formData = getValuesCreateKnowledgeTicket();
        let isExistUrlError = isDataInputUrlError(fieldListData, errorCreateKnowledgeTicket);
        if (isExistUrlError) {
            return;
        }
        return onSubmitSaveDraftKnowledgeTicket(
            props.tabId,
            props.panelType,
            formData,
            userDetail,
            corporationDetail,
            props.panelId,
            argsAll,
            fieldListData,
            aiAutoSelectedData,
            sdautoSelectedData
        );
    };

    const disabledButtonOpenCsv = () => {
        if(!selectedForm) return true;

        let infoTabCsv = panelList.find(
            p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
        );

        if(Utils.isEmptyObject(infoTabCsv)) {
            return false
        };
    
        if(!Utils.isEmptyObject(infoTabCsv)) {
            if(infoTabCsv?.tabList[0].id !== props.tabId) {
                return true;
            }
        }

        return false;
    }

    const onClickCloseTabCaseEditedCsv = () => {
        setIsShowDialogCloseTabCaseEditedCsv(false);
        setIsOpenClosePanelCsv(false);
        setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_INITIAL);
        closePanelTab({
            event: null,
            panelType: getPanelType(panelList, props.panelId),
            panelId: props.panelId,
            tabId: props.tabId
        });
        removePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData);
    }

    const onClickDuplicate = async () => {
        await viewTicketKnowledgeDetailDuplicate(props, 'ticketId', addNewPanel, setLastUserAction, false, detailTicket);
    }

    const isSystemSDAutoForm = () => {
        if (!Utils.isEmptyObject(selectedFormDetail)) {
            return Utils.isSystemSDAutoForm(selectedFormDetail)
        } else {
            let formDetail = draftTicketData?.formDetail;
            let formDetailDraft = Utils.convertJSONDataToObject(formDetail) || {};
            return Utils.isSystemSDAutoForm(formDetailDraft);
        }
    }

    const isCanDuplicate = () => {
        if (props.isDuplicate) return false;
        if (!props.isDraft) return false;

        return isShowButtonDuplicate(
            corporationDetail,
            detailTicket,
            selectedFormDetail,
            projectInuseDetail
        );
    };

    const handleResetFormData = () => {
        if (Utils.isEmptyObject(detailTicket) || Utils.isEmptyArray(fieldListData)) return;
        if (isDraftMode) {
            initDataTicketKnowledgeDraft(argsAll);
        }

        if (!Utils.isEmptyArray(fieldListData)) {
            fieldListData.forEach(field => {
                if (!Utils.isEmptyObject(field)) {
                    setValueCreateKnowledgeTicket(field.id, field.defaultValue);
                }
            });
        }

        // reset setting permission
        let dataSettingDefault = {
            viewPermission: detailTicket.viewPermission,
            editPermission: detailTicket.editPermission,
            additionalViewPermission: detailTicket.additionalViewPermission,
            additionalEditPermission: detailTicket.additionalEditPermission,
            chatPermission: detailTicket.chatPermission
        };
        setDataSettingDefaults(dataSettingDefault);

        // Clear all err
        clearErrors();
        setIsEdited(false);
        setFileUploadList([]);
        setListFieldEdited([])
        setErrorMessageHeader('');
    };

    const isShowLogInDraftMode = () => {
        return (
            !props?.isDuplicate &&
            userOfProjectList.some(prj => prj.id === detailTicket?.affiliationProject)
        );
    };


    return (
        <div className="groupCreate-main">
            <LoadingPanel isLoading={isLoading} />

            <FormProvider {...validateCreateKnowledgeTicket}>
                <FormControl className="formControl">
                    {/* btn submit */}
                    <CreateKnowledgeGroupActionButton
                        hasEditFieldPermissions={true}
                        detailTicket={detailTicket}
                        userDetail={userDetail}
                        isDisableBtnSaveTicket={isDisableButtonSent}
                        submitEditTicket={handleSubmitCreateKnowledgeTicket(onSubmitCreateKnowledgeTicket)}
                        isDisableButtonDraft={isDisableButtonDraft}
                        onClickDraft={handleSubmitSaveDraft}
                        displayMode={displayMode}
                        setDisplayMode={setDisplayMode}
                        isEdited={isEdited}
                        cancelEditTicket={handleResetFormData}
                        setIsShowDialogRestoreTicket={setIsShowDialogRestoreTicket}
                        isDuplicate={props?.isDuplicate}
                    />

                    {/* form data */}
                    <div className='groupKnow'>
                        {isSoftDeleted && (
                            <div className="form-addTicket">
                                <div className="alert-complete-delete-ticket">
                                    <p>
                                        本チケットは削除した日付から30日以内で復元可能です。
                                        <br />
                                        {moment(detailTicket.deletedAt)
                                            .add(30, 'days')
                                            .format('YYYY/MM/DD')}
                                        に自動的に完全削除されます。
                                    </p>
                                </div>
                            </div>
                        )}

                        {/* Ticket Bookmark */}
                        {(detailTicket && !props.isDuplicate) && (
                            <div className='ticket-knowledge-options-container'>
                                <TicketBookmark
                                    isViewDelete={!Utils.isEmptyString(detailTicket.deletedAt)}
                                    ticketKnowledge={detailTicket} 
                                    panelType={Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL}
                                    displayMode={displayMode}
                                    setDisplayMode={setDisplayMode}
                                    onClickDeleteTicket={() => {setIsOpenDialogConfirmDeleteDraftKnowledge(true)}}
                                    isDisplayDuplicate={isCanDuplicate()}
                                    onClickDuplicate={onClickDuplicate}
                                    setIsShowDialogDeleteTicket={setIsShowDialogDeleteTicket}
                                />
                            </div>
                        )}
                        <div className="heade-create">
                            <div className='heade-createForm' style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'nowrap' }}>
                                {/* select form */}
                                <div className="selected-form-knowledge">
                                    <div className="headeTitle">フォーマット</div>
                                    <div className="headeInfo">
                                        <div className="headeSelect">
                                            <TextField
                                                className="form-control--wrap form-control--hg40"
                                                select
                                                variant="outlined"
                                                name="selectedForm"
                                                value={selectedForm}
                                                onChange={(e) => handleOnchangeForm(e, argsAll)}
                                                disabled={
                                                    disabledAllField(panelList, props.tabId, handleStatus)
                                                    || isSoftDeleted
                                                    || displayMode === Constant.DISPLAY_MODE.VIEW
                                                }
                                                required
                                                // error
                                                SelectProps={{
                                                    MenuProps: {
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left"
                                                    },
                                                    getContentAnchorEl: null,
                                                    className: "selectDrop"
                                                    }
                                                }}
                                            >
                                                {/* normal knowledge forms */}
                                                {!Utils.isEmptyArray(knowledgeFormList) && (
                                                    <ListSubheader
                                                        className="fontw-bold select-item"
                                                        color="inherit"
                                                        disableSticky
                                                        onClickCapture={e => e.stopPropagation()}
                                                    >
                                                        {I18n.get('FIELDFORMBTN010')}
                                                    </ListSubheader>
                                                )}
                                                {!Utils.isEmptyArray(knowledgeFormList) &&
                                                    knowledgeFormList.map((item) => {
                                                        return (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                <OverFlowTooltipWithTabsMui
                                                                    value={Utils.getTextByLanguage(
                                                                        Constant.LANGUAGE_TYPE.JP,
                                                                        item.name
                                                                    )}
                                                                />
                                                            </MenuItem>
                                                        );
                                                })}

                                                {/* ai auto knowledge forms */}
                                                {!Utils.isEmptyArray(knowledgeAIAutoFormList) && (
                                                    <ListSubheader
                                                        className="fontw-bold select-item"
                                                        color="inherit"
                                                        disableSticky
                                                        onClickCapture={e => e.stopPropagation()}
                                                    >
                                                        {I18n.get('TAGBTN028')}
                                                    </ListSubheader>
                                                )}
                                                {!Utils.isEmptyArray(knowledgeAIAutoFormList) &&
                                                    knowledgeAIAutoFormList.map((item) => {
                                                        return (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                <OverFlowTooltipWithTabsMui
                                                                    value={Utils.getTextByLanguage(
                                                                        Constant.LANGUAGE_TYPE.JP,
                                                                        item.name
                                                                    )}
                                                                />
                                                            </MenuItem>
                                                        );
                                                })}

                                                {/* sd auto script knowledge forms */}
                                                {!Utils.isEmptyArray(knowledgeSDAutoFormList) && (
                                                    <ListSubheader
                                                        className="fontw-bold select-item"
                                                        color="inherit"
                                                        disableSticky
                                                        onClickCapture={e => e.stopPropagation()}
                                                    >
                                                        {I18n.get('TAGBTN030')}
                                                    </ListSubheader>
                                                )}
                                                {!Utils.isEmptyArray(knowledgeSDAutoFormList) &&
                                                    knowledgeSDAutoFormList.map((item) => {
                                                        return (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                <OverFlowTooltipWithTabsMui
                                                                    value={Utils.getTextByLanguage(
                                                                        Constant.LANGUAGE_TYPE.JP,
                                                                        item.name
                                                                    )}
                                                                />
                                                            </MenuItem>
                                                        );
                                                })}

                                                {/* business app knowledge forms */}
                                                {!Utils.isEmptyArray(businessAppFormList) && (
                                                    <ListSubheader
                                                        className="fontw-bold select-item"
                                                        color="inherit"
                                                        disableSticky
                                                        onClickCapture={e => e.stopPropagation()}
                                                    >
                                                        {I18n.get('TAGBTN031')}
                                                    </ListSubheader>
                                                )}
                                                {!Utils.isEmptyArray(businessAppFormList) &&
                                                    businessAppFormList.map((item) => {
                                                        return (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                <OverFlowTooltipWithTabsMui
                                                                    value={Utils.getTextByLanguage(
                                                                        Constant.LANGUAGE_TYPE.JP,
                                                                        item.name
                                                                    )}
                                                                />
                                                            </MenuItem>
                                                        );
                                                })}

                                                {/* master knowledge forms */}
                                                {!Utils.isEmptyArray(masterKnowledgeFormList) && (
                                                    <ListSubheader
                                                        className="fontw-bold select-item"
                                                        color="inherit"
                                                        disableSticky
                                                        onClickCapture={e => e.stopPropagation()}
                                                    >
                                                        {I18n.get('TAGBTN002')}
                                                    </ListSubheader>
                                                )}
                                                {!Utils.isEmptyArray(masterKnowledgeFormList) &&
                                                    masterKnowledgeFormList.map((item) => {
                                                        return (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                <OverFlowTooltipWithTabsMui
                                                                    value={Utils.getTextByLanguage(
                                                                        Constant.LANGUAGE_TYPE.JP,
                                                                        item.name
                                                                    )}
                                                                />
                                                            </MenuItem>
                                                        );
                                                })}

                                                {/* synonym knowledge forms */}
                                                {!Utils.isEmptyArray(synonymKnowledgeFormList) && (
                                                    <ListSubheader
                                                        className="fontw-bold select-item"
                                                        color="inherit"
                                                        disableSticky
                                                        onClickCapture={e => e.stopPropagation()}
                                                    >
                                                        {I18n.get('TAGBTN029')}
                                                    </ListSubheader>
                                                )}
                                                {!Utils.isEmptyArray(synonymKnowledgeFormList) &&
                                                    synonymKnowledgeFormList.map((item) => {
                                                        return (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                <OverFlowTooltipWithTabsMui
                                                                    value={Utils.getTextByLanguage(
                                                                        Constant.LANGUAGE_TYPE.JP,
                                                                        item.name
                                                                    )}
                                                                />
                                                            </MenuItem>
                                                        );
                                                })}
                                            </TextField>
                                        </div>
                                        {isErrorSelected && (
                                            <>
                                                <span className="message-error">
                                                    {I18n.get('COMMSG005')}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className='header-btn-opencsv'>
                                    <Button
                                        disabled={
                                            disabledButtonOpenCsv()
                                            || disabledAllField(panelList, props.tabId, handleStatus)
                                            || isSoftDeleted
                                        }
                                        className="btn-open-upload-csv btn-light btn-hg32"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            addNewPanel({
                                                type: Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV,
                                                tabId: props.tabId,
                                                props: {
                                                    ...props,
                                                    selectedForm: selectedForm,
                                                }, 
                                            });
                                        }}
                                        startIcon={<UpLoadCSVIcon />}
                                    >
                                        一括投稿
                                    </Button>
                                </div>                
                            </div>
                        </div>

                        <div className="scrollBar-main">
                            <div className="addTicket">
                                <SettingPermissionKnowledgeTicket 
                                    {...argsAll}
                                    parentScreen={"CreateTicket"}
                                    dataSettingDefaults={dataSettingDefaults}
                                    hasEditSettingPermissions={isProjectManager}
                                    displayMode={displayMode}
                                />
                                <ErrorMessageHeader message={errorMessageHeader} />

                                {!Utils.isEmptyArray(fieldListData) &&
                                    fieldListData
                                        ?.filter((field) => field.type !== 'WORKFLOW')
                                        .map((fieldData, i, filteredArray) => {
                                            // Skip end fields of paired fields (rendered with start field)
                                            if (AI_TELEPHONE_SKIP_FIELDS.includes(fieldData.sysField)) {
                                                return null;
                                            }

                                            if(disabledAllField(panelList, props.tabId, handleStatus)) {
                                                fieldData.structure.publicForCustomer = Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW;
                                            }

                                            // Helper function to build props for a field
                                             const buildFieldProps = (field) => {
                                                // Find paired field ids for date auto-adjustment
                                                let pairedEndFieldId = null;
                                                let pairedStartFieldId = null;
                                                if (field.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE) {
                                                    const endField = filteredArray.find(f => 
                                                        f.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE
                                                    );
                                                    pairedEndFieldId = endField?.fieldId;
                                                }
                                                if (field.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE) {
                                                    const startField = filteredArray.find(f => 
                                                        f.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE
                                                    );
                                                    pairedStartFieldId = startField?.fieldId;
                                                }
                                                
                                                return {
                                                    API: props?.API,
                                                    UI: field.structure.UI,
                                                    label: field.fieldLabel
                                                        ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.fieldLabel)
                                                        : '',
                                                    errorlist: errorCreateKnowledgeTicket,
                                                    name: field.fieldId,
                                                    data: field,
                                                    defaultValue: currentPanelInitData.formData && currentPanelInitData.formData[field.fieldId] 
                                                        ? currentPanelInitData.formData[field.fieldId] 
                                                        : null,
                                                    triggerValidate: triggerValidate,
                                                    fileUploadList: fileUploadList,
                                                    setFileUploadList: setFileUploadList,
                                                    setFileUpdatedList: setFileUpdatedList,
                                                    fileUpdatedList: fileUpdatedList,
                                                    register: registerCreateKnowledgeTicket,
                                                    setValue: setValueCreateKnowledgeTicket,
                                                    getValues: getValuesCreateKnowledgeTicket,
                                                    clearErrors: clearErrors,
                                                    control: controlValueCreateKnowledgeTicket,
                                                    autoFillObject: autoFillObject,
                                                    setAutoFillObject: setAutoFillObject,
                                                    isExChangeTagField: isExChangeTagField,
                                                    setIsExChangeTagField: setIsExChangeTagField,
                                                    listFieldEdited: listFieldEdited,
                                                    setListFieldEdited: setListFieldEdited,
                                                    isEdited: isEdited,
                                                    setIsEdited: setIsEdited,
                                                    setOnChangeEdit: setOnChangeEdit,
                                                    onChangeEdit: onChangeEdit,
                                                    parentForm: selectedFormInfo,
                                                    panelId: props.panelId,
                                                    tabId: props.tabId,
                                                    panelInitData: panelInitData,
                                                    setPanelInitData: setPanelInitData,
                                                    panelList: panelList,
                                                    editTicket: true,
                                                    detailTicket: detailTicket,
                                                    isLoading: isLoading,
                                                    setIsLoading: setIsLoading,
                                                    addTicket: true,
                                                    flagReset: flagReset,
                                                    setFlagReset: setFlagReset,
                                                    isDisplaySplitPdfSwitch: Utils.isDisplaySplitPdfSwitch(corporationDetail),
                                                    currentUserDetail: userDetail,
                                                    addNewPanel: addNewPanel,
                                                    projectInuseDetail: projectInuseDetail,
                                                    isShowIconCopyFieldId: false,
                                                    isDuplicate: props?.isDuplicate,
                                                    submitTime: submitTime,
                                                    onClickUrlViewTicket: onClickUrlViewTicket,
                                                    optionsOfTagField: optionsOfTagField,
                                                    setOptionsOfTagField: setOptionsOfTagField,
                                                    fieldListData: fieldListData,
                                                    isDraftMode: isDraftMode,
                                                    isTicketKnowledge: true,
                                                    setCurrentPanelInitData: setCurrentPanelInitData,
                                                    aiAutoSelectedData: aiAutoSelectedData,
                                                    setAIAutoSelectedData: setAIAutoSelectedData,
                                                    sdautoSelectedData: sdautoSelectedData,
                                                    setSdautoSelectedData: setSdautoSelectedData,
                                                    aiTelephoneSelectedData: aiTelephoneSelectedData,
                                                    setAITelephoneSelectedData: setAITelephoneSelectedData,
                                                    isSystemSDAutoForm: isSystemSDAutoForm(),
                                                    hasEditFieldPermissions: hasEditPermissionWithSpecialCase(
                                                        field, detailTicket, projectInuseDetail, isProjectManager, displayMode, props?.isDuplicate
                                                    ),
                                                    displayMode: displayMode,
                                                    allFormData: allFormData,
                                                    selectedFormDetail: selectedFormInfo,
                                                    sysField: fieldData.sysField,
                                                    pairedEndFieldId: pairedEndFieldId,
                                                    pairedStartFieldId: pairedStartFieldId,
                                                    aiTelephoneEndDateValue: aiTelephoneEndDateValue,
                                                    setAiTelephoneEndDateValue: setAiTelephoneEndDateValue,
                                                    affiliationProjectOfTicket: projectInuseDetail
                                                };
                                            };

                                            // Check if this is a paired start field
                                            const pairedEndFieldSysField = AI_TELEPHONE_PAIRED_FIELDS[fieldData.sysField];
                                            if (pairedEndFieldSysField) {
                                                const endFieldData = filteredArray.find(f => f.sysField === pairedEndFieldSysField);
                                                if (endFieldData) {
                                                    // Apply disabled state to end field if needed
                                                    if (disabledAllField(panelList, props.tabId, handleStatus)) {
                                                        endFieldData.structure.publicForCustomer = Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW;
                                                    }
                                                    // Render both fields in a flex row
                                                    return (
                                                        <Box 
                                                            key={fieldData.fieldId}
                                                            display="flex" 
                                                            flexDirection="row" 
                                                            style={{ width: '100%', gap: '16px' }}
                                                        >
                                                            <Box style={{ flex: 1, minWidth: 0 }}>
                                                                <WrapRenderFieldUI {...buildFieldProps(fieldData)} />
                                                            </Box>
                                                            <Box style={{ flex: 1, minWidth: 0 }}>
                                                                <WrapRenderFieldUI {...buildFieldProps(endFieldData)} />
                                                            </Box>
                                                        </Box>
                                                    );
                                                }
                                            }

                                            // Normal single field render
                                            return (
                                                    <WrapRenderFieldUI
                                                    key={fieldData.fieldId}
                                                    {...buildFieldProps(fieldData)}
                                                />
                                            );
                                        })}

                                {isShowLogInDraftMode() && isShowAiAutoLog && (
                                    <div className="ai-auto-log-wrapper">
                                        <AiAutoLog
                                            corporationDetail={corporationDetail}
                                            selectedProject={projectInuseDetail}
                                            currentUserDetail={userDetail}
                                            ticketDetail={detailTicket}
                                            panelId={props.panelId}
                                            isDisabled={false}
                                        />
                                    </div>
                                )}

                                {isShowLogInDraftMode() && isShowSDautoLog && (
                                    <div className="sd-auto-log-wrapper">
                                        <SDautoLog
                                            corporationDetail={corporationDetail}
                                            selectedProject={projectInuseDetail}
                                            currentUserDetail={userDetail}
                                            ticketDetail={detailTicket}
                                            panelId={props.panelId}
                                            isDisabled={false}
                                        />
                                    </div>
                                )}

                                {isShowLogInDraftMode() && isShowAITelephonePromptLog && (
                                    <div className="telephone-prompt-log-warp">
                                        <TelephonePromptLog
                                            corporationDetail={corporationDetail}
                                            selectedProject={projectInuseDetail}
                                            currentUserDetail={userDetail}
                                            ticketDetail={detailTicket}
                                            panelId={props?.panelId}
                                            isDisabled={false}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </FormControl>
            </FormProvider>

            {/* Dialog group */}
            <DataChangePleaseReloadModal
                {...argsAll}
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <DialogSelectFormKnowledgeTicket argsAll={argsAll}/>
            <DialogConfirmCancelCreateTicket
                onClickSaveDraft={handleSubmitSaveDraft}
                handleSubmitSentDraft={handleSubmitCreateKnowledgeTicket(onSubmitCreateKnowledgeTicket)}
                {...argsAll}
                isDisableButtonSend={isDisableButtonSent}
                setErrorCreateTicket={setErorsCreateKnowledgeTicket}
                getValuesCreateTicket={getValuesCreateKnowledgeTicket}
                fieldListData={fieldListData}
                setSubmitTime={setSubmitTime}
                isDuplicate={props?.isDuplicate}
                removePanelInitData={removePanelInitData}
                panelInitData={panelInitData}
                setPanelInitData={setPanelInitData}
            />
            
            {/* Soft delete ticket */}
            <ConfirmDialog 
                isOpen={isOpenDialogConfirmDeleteDraftKnowledge}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT')}
                closeCallBack={(e, reason) => closeCallbackDeleteDraftKnowledgeButton(e, reason, argsAll)}
                okCallBack={() => {
                    acceptSoftDeleteDraftKnowledgeButton(argsAll.API, detailTicket, userDetail, argsAll);
                    setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                }}
                textSubmit={I18n.get('CM-BUTTON-OK')}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
            />

            {/* Restore ticket*/}
            <ConfirmDialog 
                isOpen={isShowDialogRestoreTicket}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-RESTORE-CONTENT')}
                closeCallBack={(e, reason) => closeCallbackRestoreKnowledgeTicketButton(e, reason, argsAll)}
                okCallBack={() => {
                    acceptRestoreKnowledgeTicketDraft(
                        props?.API,
                        detailTicket,
                        userDetail,
                        argsAll
                    )
                    setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                }}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />

            {/* Hard Delete ticket */}
            <ConfirmDialog
                isOpen={isShowDialogDeleteTicket}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-COMPLETELY')}
                closeCallBack={() => setIsShowDialogDeleteTicket(false)}
                okCallBack={() => acceptHardDeleteKnowledgeTicket(
                    props?.API,
                    detailTicket,
                    userDetail,
                    argsAll,
                    setIsOpenModalReloadPage
                )}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            
            <ConfirmDialog 
                isOpen={isShowPopUpConfirmChangeForm.status}
                msgConfirm={I18n.get('KNOWCRMSG004')}
                closeCallBack={() => setIsShowPopUpConfirmChangeForm({status: false})}
                okCallBack={async () => await onChangeFormCsv(argsAll, isShowPopUpConfirmChangeForm.projectTargetSelected)}
            />
            <ConfirmDialog 
                isOpen={isShowDialogCloseTabCaseEditedCsv}
                msgConfirm={I18n.get('COMMSG043')}
                closeCallBack={() => setIsShowDialogCloseTabCaseEditedCsv(false)}
                okCallBack={onClickCloseTabCaseEditedCsv}
                textClose={I18n.get('COMBTN007')}
            />
            <ConfirmDialog 
                isOpen={isOpenClosePanelCsv}
                msgConfirm={I18n.get('KNOWCRMSG006')}
                closeCallBack={() => onClosePanelCsv()}
                okCallBack={() => onClickCloseTabCaseEditedCsv()}
                textClose={I18n.get('COMBTN007')}
            />

            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={I18n.get('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={'はい'}
            />
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={e => setIsOpenAccessDeniedPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={I18n.get('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />
            <ConfirmDialog
                isOpen={isShowPopupLogout}
                msgConfirm={<div><span>{I18n.get('MSG-CM-EXPIRED-SESSION-1')}</span><br/><span>{I18n.get('MSG-CM-EXPIRED-SESSION-2')}</span></div>}
                textSubmit={I18n.get('COMBTN004')}
                okCallBack={() => signOut()}
                cancelCallBack={() => setIsShowPopupLogout(false)}
                cancelClassName={'btn-confirm-cancel'}
            />
        </div>
    );
}
